import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box, Stack } from "@mui/material";

const TransactionListByCustomer = (props) => {
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [customerid, setCustomerID] = useState(0);
  const [totalData, setTotalData] = useState({
    amount:0,
    openbalance:0,
  });  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const ITEMS_PER_PAGE = 10;
  const locationid = localStorage.getItem("Location");

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName,
    // + '(' + option.FirstName + " " + option.LastName + ')'
  }));

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/transactionlistbycustomer?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&customerid=${customerid}&locationid=${locationid}&usertype=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            OpenBalance: Number(el?.OpenBalance) || 0,
            Amount: Number(el?.Amount) || 0,
          }));
          setResponseData(FilterData);
          setTotalData({
            ...totalData,
            amount: FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.Amount) || 0),
              0
            ),
            openbalance: FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.OpenBalance) || 0),
              0
            ),
        });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const paramObject = useParams();
  // useEffect(() => {
  //   setLoading(true);
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/transactionlistbycustomer?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}&customerid=${customerid}&locationid=${locationid}&usertype=1`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData);
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         setData(res.data.ResponseData);
  //         setRowCount(res.data.ResponseData[0].TotalRecords);

  //         console.log("11", responseData);
  //         //   barcodeRefs.current = responseData;
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  //   customerid,
  // ]);

  //Function for export excel

  // to calculate the total

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: 120,
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return moment(Date).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.TxnId}`
                : row.original?.TransactionType === "Invoice" ||
                  row.original?.TransactionType === "Return/ Memo"
                ? `/sales-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : row.original?.TransactionType === "Expense"
                ? `/Expense/${row.original.TxnId}`
                : "#";

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: 120,
    },
    {
      header: "Memo/Description",
      accessorKey: "MemoDescription",
    },
    {
      header: "Account",
      accessorKey: "Account",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: 120,
      Cell: ({ row }) => {
        const TotalAmount = row?.original?.Amount;
        const TransactionType = row?.original?.TransactionType;

        return (
          <div style={{ textAlign: "end" }}>
            {TransactionType === "Journal Entry"
              ? "-"
              : CurrencySymbols(
                  Number(TotalAmount),
                  { CurrencySymbol },
                  FractionDigits
                )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedUser",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModifiedDate",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedUser",
    },
    {
      header: "Customer",
      accessorKey: "Customer",
    },
    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "Split",
      accessorKey: "AccountFullName",
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
    },
    {
      header: "Shipping Address",
      accessorKey: "ShippingAddress",
    },
    {
      header: "Ship Date",
      accessorKey: "ShipDate",
      Cell: ({ row }) => {
        const ShipDate = row?.original?.ShipDate;
        if (ShipDate === "00-00-0000" || ShipDate === "" || ShipDate === null) {
          return "";
        }
        return moment(ShipDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Ship Via",
      accessorKey: "ShipVia",
    },
    {
      header: "Tracking #",
      accessorKey: "Trackingnumber",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
      size: 120,
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 130,
      Cell: ({ row }) =>
        moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`) ===
        "Invalid date"
          ? ""
          : moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Customer/Vendor Message",
      accessorKey: "CustomerVendorMessage",
    },
    {
      header: "Invoice Date",
      accessorKey: "InvoiceDate",
      size: 150,
      Cell: ({ row }) => {
        const InvoiceDate = row?.original?.InvoiceDate;
        if (
          InvoiceDate === "00-00-0000" ||
          InvoiceDate === "" ||
          InvoiceDate === null
        ) {
          return "";
        }
        return moment(InvoiceDate).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "A/R Paid",
      accessorKey: "ARPaid",
      size: 130,
    },
    {
      header: "Delivery Address",
      accessorKey: "DeliveryAddress",
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: 160,
      Cell: ({ row }) => {
        const Balance = parseFloat(row?.original?.OpenBalance);

        if (isNaN(Balance) || Balance === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {CurrencySymbols(
                Number(Balance),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Transaction List By Customer</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Transaction List By Customer
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                {/* </div> */}
              </div>
            )}
            {/* <div className=" mt-0 col-md-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Customer
              </label>

              <Select
                defaultValue={customerid}
                onChange={(event) => {
                  setCustomerID(event?.value);
                }}
                options={customerDropDown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select mt-1"
              />
            </div> */}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Transaction List By Customer
                    </p>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Transaction List By Customer"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnsVisibility={{
                      CreatedDate: false,
                      CreatedUser: false,
                      LastModifiedDate: false,
                      LastModifiedUser: false,
                      ShipDate: false,
                      PaymentMethod: false,
                      CustomerVendorMessage: false,
                      InvoiceDate: false,
                      Terms: false,
                      ShipVia: false,
                      AccountFullName: false,
                      BillingAddress: false,
                      ShippingAddress: false,
                      DeliveryAddress: false,
                      POStatus: false,
                      DueDate: false,
                      ARPaid: false,
                      APPaid: false,
                      Employee: false,
                      OpenBalance: false,
                      Trackingnumber: false,
                    }}
                    columnGrouping={["Customer"]}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    enableRowSelection={false}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <div style={{  marginTop: "5px" }}>
                  {/* textAlign: "end", */}
                    <>
                      <Stack style={{ fontWeight: "bold" }}>
                        Total Amount:{" "}
                        {CurrencySymbols(
                          Number(totalData.amount).toFixed(FractionDigits),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </Stack>
                      <Stack style={{ fontWeight: "bold" }}>
                        Total Open Balance:{" "}
                        {CurrencySymbols(
                          Number(totalData.openbalance).toFixed(FractionDigits),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </Stack>
                    </>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TransactionListByCustomer;
